import { removeSpaces } from "./stringUtil";

export const redirectToId = (id: string) => window.history.replaceState('', id ? `User ${id}` : 'ParPass Validation', `?id=${removeSpaces(id)}`)